var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutoPurcahseReplenishmentIconBlue2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 28.5,
    fill: "white",
    fillOpacity: 0.25,
    stroke: "#5D5FEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50963_31362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8993 13.7656H24.0593C23.2456 13.7656 22.5859 14.4253 22.5859 15.239V18.1856C22.5859 18.9993 23.2456 19.659 24.0593 19.659H32.8993C33.713 19.659 34.3726 18.9993 34.3726 18.1856V15.239C34.3726 14.4253 33.713 13.7656 32.8993 13.7656Z",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3675 16.7109H37.3142C38.0957 16.7109 38.8452 17.0214 39.3978 17.574C39.9504 18.1266 40.2609 18.8761 40.2609 19.6576V26.7958M22.5808 16.7109H19.6342C18.8527 16.7109 18.1032 17.0214 17.5506 17.574C16.998 18.1266 16.6875 18.8761 16.6875 19.6576V40.2843C16.6875 41.0658 16.998 41.8153 17.5506 42.3679C18.1032 42.9205 18.8527 43.231 19.6342 43.231H26.7812",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2266 23.7812H27.5932",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2266 26.1406H23.4679",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1562 37.1592V36.2699C30.1562 35.7444 30.5857 35.3099 31.1163 35.3099C32.0308 35.3099 32.4047 34.6632 31.9449 33.8699C31.6822 33.4151 31.8388 32.8239 32.2986 32.5612L33.1728 32.061C33.5719 31.8235 34.0873 31.965 34.3248 32.3641L34.3804 32.4601C34.8351 33.2534 35.583 33.2534 36.0428 32.4601L36.0983 32.3641C36.3358 31.965 36.8512 31.8235 37.2504 32.061L38.1245 32.5612C38.5843 32.8239 38.741 33.4151 38.4782 33.8699C38.0184 34.6632 38.3923 35.3099 39.3069 35.3099C39.8324 35.3099 40.2669 35.7394 40.2669 36.2699V37.1592C40.2669 37.6847 39.8374 38.1193 39.3069 38.1193C38.3923 38.1193 38.0184 38.766 38.4782 39.5593C38.741 40.0191 38.5843 40.6052 38.1245 40.868L37.2504 41.3682C36.8512 41.6057 36.3358 41.4642 36.0983 41.065L36.0428 40.969C35.588 40.1757 34.8402 40.1757 34.3804 40.969L34.3248 41.065C34.0873 41.4642 33.5719 41.6057 33.1728 41.3682L32.2986 40.868C31.8388 40.6052 31.6822 40.0141 31.9449 39.5593C32.4047 38.766 32.0308 38.1193 31.1163 38.1193C30.5857 38.1193 30.1562 37.6847 30.1562 37.1592Z",
    stroke: "#5D5FEF",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2098 37.8883C35.8563 37.8883 36.3804 37.3641 36.3804 36.7176C36.3804 36.071 35.8563 35.5469 35.2098 35.5469C34.5632 35.5469 34.0391 36.071 34.0391 36.7176C34.0391 37.3641 34.5632 37.8883 35.2098 37.8883Z",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2734 36.5C27.2734 38.0822 27.7426 39.629 28.6217 40.9446C29.5007 42.2602 30.7502 43.2855 32.212 43.891C33.6738 44.4965 35.2823 44.655 36.8342 44.3463C38.386 44.0376 39.8115 43.2757 40.9303 42.1568C42.0491 41.038 42.811 39.6126 43.1197 38.0607C43.4284 36.5089 43.27 34.9003 42.6645 33.4385C42.059 31.9767 41.0336 30.7273 39.718 29.8482C38.4024 28.9692 36.8557 28.5 35.2734 28.5C33.0369 28.5084 30.8903 29.3811 29.2823 30.9356L27.2734 32.9444",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4957 32.941H27.2734V30.7188",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50963_31362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(11.4766 11.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoPurcahseReplenishmentIconBlue2);
export default __webpack_public_path__ + "static/media/AutoPurcahseReplenishmentIconBlue2.d98f750cc51ef110236186c81014fc3a.svg";
export { ForwardRef as ReactComponent };